const FooterSection = () => {
  const handleAnchor = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="relative bg-[#050508] border-t border-red-900/20 overflow-hidden">
      {/* Background wireframe map effect */}
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: `
            linear-gradient(rgba(220,38,38,0.4) 1px, transparent 1px),
            linear-gradient(90deg, rgba(220,38,38,0.4) 1px, transparent 1px)
          `,
          backgroundSize: '40px 40px',
        }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-6 pt-16 pb-8">
        {/* Top Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-14">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="mb-4">
              <span className="font-['Exo_2'] font-black text-white text-xl tracking-widest uppercase">
                ELLE NOLO
              </span>
              <div className="h-[2px] w-16 bg-gradient-to-r from-red-600 to-transparent mt-1" />
              <span className="font-['Exo_2'] font-light text-gray-500 text-xs tracking-[0.3em] uppercase block mt-1">
                Equipment Srl
              </span>
            </div>
            <p className="font-['Inter'] text-gray-600 text-xs leading-relaxed mb-6">
              Noleggio professionale di attrezzature per motorsport, eventi fieristici, catering e ricambistica auto.
              Attivi in tutta Europa.
            </p>
            <div className="flex items-center gap-3">
              {['ri-instagram-line', 'ri-linkedin-line', 'ri-facebook-line'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-8 h-8 flex items-center justify-center border border-gray-800 rounded-md text-gray-500 hover:border-red-600/50 hover:text-red-400 transition-all duration-300 cursor-pointer"
                >
                  <i className={`${icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-['Exo_2'] font-bold text-white text-sm tracking-widest uppercase mb-5">
              <a href="#servizi" onClick={(e) => handleAnchor(e, '#servizi')}>Servizi</a>
            </h4>
            <ul className="flex flex-col gap-3">
              {['Motorsport', 'Eventi Fieristici', 'Catering & Hospitality', 'Ricambistica Auto', 'Energia & Generatori', 'Camper & Veicoli'].map((item) => (
                <li key={item}>
                  <a
                    href="#servizi"
                    onClick={(e) => handleAnchor(e, '#servizi')}
                    className="font-['Inter'] text-gray-600 text-xs hover:text-red-400 transition-colors cursor-pointer"
                    rel="nofollow"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-['Exo_2'] font-bold text-white text-sm tracking-widest uppercase mb-5">
              <a href="#chi-siamo" onClick={(e) => handleAnchor(e, '#chi-siamo')}>Azienda</a>
            </h4>
            <ul className="flex flex-col gap-3">
              {[
                { label: 'Chi Siamo', href: '#chi-siamo' },
                { label: 'La Nostra Flotta', href: '#galleria' },
                { label: 'Contatti', href: '#contatti' },
              ].map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    onClick={(e) => handleAnchor(e, item.href)}
                    className="font-['Inter'] text-gray-600 text-xs hover:text-red-400 transition-colors cursor-pointer"
                    rel="nofollow"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-['Exo_2'] font-bold text-white text-sm tracking-widest uppercase mb-5">
              Contatti
            </h4>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-phone-line text-red-500 text-xs" />
                </div>
                <a href="tel:+390550620108" className="font-['Inter'] text-gray-500 text-xs hover:text-white transition-colors cursor-pointer">
                  +39 055 0620108
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-mail-line text-orange-500 text-xs" />
                </div>
                <a href="mailto:ellenoloequipmentsrl@gmail.com" className="font-['Inter'] text-gray-500 text-xs hover:text-white transition-colors cursor-pointer break-all">
                  ellenoloequipmentsrl@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-gray-500 text-xs" />
                </div>
                <span className="font-['Inter'] text-gray-500 text-xs">
                  Firenze, Italia<br />
                  <span className="text-gray-600">Attivi in tutta Europa</span>
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="h-[1px] bg-gradient-to-r from-transparent via-red-900/30 to-transparent mb-8" />

        {/* Bottom Bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <span className="font-['Inter'] text-gray-700 text-xs">
            &copy; {new Date().getFullYear()} ELLE NOLO EQUIPMENT Srl. Tutti i diritti riservati.
          </span>
          <div className="flex items-center gap-6">
            <a href="#" className="font-['Inter'] text-gray-700 text-xs hover:text-gray-500 transition-colors cursor-pointer" rel="nofollow">
              Privacy Policy
            </a>
            <a href="#" className="font-['Inter'] text-gray-700 text-xs hover:text-gray-500 transition-colors cursor-pointer" rel="nofollow">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
